import React from 'react';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Mark } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { feed, picks } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Activity = () => {
  const { liked, toggleLike, showToast } = useWeb();

  return (
    <>
      <div className="web-h">
        <div>
          <h1>For you</h1>
          <p>Picks and what is happening on Focalyt.</p>
        </div>
      </div>
      <div className="web-grid two">
        <div>
          {picks.map((pick) => (
            <article className="web-card web-row" key={pick.title} style={{ marginBottom: 12 }}>
              <Mark name={pick.icon} from={pick.from} to={pick.to} />
              <div className="web-grow">
                <b>{pick.title}</b>
                <div className="web-mut">{pick.reason}</div>
                <button type="button" className="web-btn soft" style={{ marginTop: 8 }} onClick={() => showToast(pick.action)}>
                  {pick.action}
                </button>
              </div>
            </article>
          ))}
        </div>
        <div>
          {feed.map((item, index) => (
            <article className="web-card web-row" key={item.name} style={{ marginBottom: 12 }}>
              <span className="web-av">{item.name[0]}</span>
              <div className="web-grow">
                <div><b>{item.name}</b> {item.text}</div>
                <div className="web-mut">{item.time}</div>
                <button type="button" className="web-btn soft" style={{ marginTop: 8 }} onClick={() => toggleLike(index)}>
                  <Icon name="heart" /> {item.likes + (liked[index] ? 1 : 0)}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </>
  );
};

export default Activity;
